import { WalletAccountType } from 'types';

export const READ_ONLY_WALLET_TYPES = [WalletAccountType.ADNALES];
